<button
  *ngIf="options.closeButton"
  (click)="remove(); $event.stopPropagation(); trackNotificationDismiss()"
  class="toast-close-button"
  aria-label="Close"
>
  <span aria-hidden="true">&times;</span>
</button>
<div *ngIf="title" [class]="options.titleClass" [attr.aria-label]="title">
  {{ title }} <ng-container *ngIf="duplicatesCount">[{{ duplicatesCount + 1 }}]</ng-container>
</div>
<div
  *ngIf="message && options.enableHtml"
  role="alertdialog"
  aria-live="polite"
  [class]="options.messageClass"
  [innerHTML]="message"
>
  <p [innerHTML]="message"></p>
</div>
<div
  *ngIf="message && !options.enableHtml"
  role="alertdialog"
  aria-live="polite"
  [class]="options.messageClass"
  [attr.aria-label]="message"
>
  {{ message }}
</div>
<div *ngIf="options.progressBar">
  <div class="toast-progress" [style.width]="width + '%'"></div>
</div>
<div class="aiDetectionDetails" *ngIf="alarm?.type?.toLowerCase() === 'ai detection'">
  <div *ngIf="alarm.details?.cameraDetail?.name">
    Camera: {{ alarm.details?.cameraDetail?.name }}
  </div>
  <div *ngIf="alarm.details?.label">Label: {{ alarm.details?.label }}</div>
  <img
    *ngIf="alarm?.thumbnailUrl"
    class="alertMedia"
    mat-card-image
    square
    [src]="alarm.thumbnailUrl"
  />
</div>
<div class="toastActions">
  <button
    mat-icon-button
    [matTooltip]="this.customToolTip()"
    (click)="muteAlarmReasons()"
    *ngIf="alarm?.type.toLowerCase().indexOf('lpr') > -1"
  >
    <sn-icon size="sm">notifications_paused</sn-icon>
  </button>
  <button mat-icon-button (click)="viewAlert(); $event.stopPropagation()" *ngIf="hasCoordinates">
    <mat-icon size="sm" matTooltip="Show on Map" matTooltipPosition="above">gps_fixed</mat-icon>
  </button>
  <button
    mat-icon-button
    (click)="dockCameras(); $event.stopPropagation()"
    *ngIf="alarm?.geometry && this.autoDockMaxCameras > 0 && hasCoordinates"
  >
    <mat-icon size="sm" matTooltip="Dock Cameras" matTooltipPosition="above">videocam</mat-icon>
  </button>
</div>
